if (!customElements.get('quick-view-drawer')) {
  class QuickViewDrawer extends MenuDrawer {
    constructor() {
      super();

      this.setClasses({
        open: 'quick-view--open',
        opening: 'quick-view--opening',
        closing: 'quick-view--closing'
      });

      this.addEventListener('close', () => {
        const drawerContent = this.querySelector('.quick-view__content');
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');

        document.dispatchEvent(new CustomEvent('quickview:close'));
      });

      this.addEventListener('click', (event) => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;

        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;

        event.preventDefault();
        event.stopPropagation();
      }, true);
    }
  }
  customElements.define('quick-view-drawer', QuickViewDrawer);
}

if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }

    handleIntersection(entries, _observer) {
      if (!entries[0].isIntersecting) return;

      const selector = '.quick-view__content';
      const drawerContent = this.querySelector(selector);
      let productUrl = this.dataset.productUrl.split('?');
      let sectionUrl = '';
      if(productUrl.length > 1 && productUrl[1].includes('variant=')) {
        productUrl = productUrl[0] + '?' + productUrl[1];
        sectionUrl = `${productUrl}&view=modal`;
      } else {
        productUrl = productUrl[0];
        sectionUrl = `${productUrl}?view=modal`;
      }

      fetch(sectionUrl)
        .then(response => response.text())
        .then(responseText => {
          setTimeout(() => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector(selector);
            this.setInnerHTML(drawerContent, productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }, 200);

          setTimeout(() => {
            drawerContent.classList.add('hide-cover');

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            }));
          }, 500);
        })
        .catch(e => {
          console.error(e);
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  }
  customElements.define('quick-view', QuickView);
}
